import { Grid, Box, Typography } from '@vapor/material'
import { useTranslation } from 'react-i18next'
import { FiscalType, PaymentActivesQuery } from 'src/api/api.generated'
import PaymentSplitter from '../../../../../components/payment/payment-splitter/payment-splitter'
import { PaymentRowAmount, PaymentSplitterError } from '../../../../../components/payment/payment-splitter/payment-splitter.types'

export type PaymentsFormFieldProps = {
  fiscalType: FiscalType
  amount: number | null | undefined
  value: PaymentRowAmount[] | null | undefined
  onChange: (payments: PaymentRowAmount[]) => void
  error?: PaymentSplitterError
  readonly?: boolean
  loading?: boolean
  dataForGatewayPayment: (amount?: number | null, paymentActivesWithGateway?: PaymentActivesQuery, blockAmountChanges?: boolean) => void
  paymentActives: PaymentActivesQuery | undefined
  depositCreation?: true
  /** Allow to change payment methods of read only document */
  allowPaymentMethodsChanges?: boolean
}

export default function PaymentsFormField({
  fiscalType,
  amount,
  value,
  onChange,
  error,
  readonly,
  loading,
  paymentActives,
  dataForGatewayPayment,
  depositCreation,
  allowPaymentMethodsChanges,
}: PaymentsFormFieldProps) {
  const { t } = useTranslation()

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="label">{t('pms.common.checkout_document.payments')}</Typography>
      </Grid>
      <Grid item xs={12}>
        {/* {JSON.stringify(value)} */}
        <Box sx={{ py: 1 }}>
          {allowPaymentMethodsChanges ? (
            <PaymentSplitter //
              fiscalType={fiscalType}
              amount={amount || 0}
              value={value || []}
              onChange={onChange}
              error={error}
              disabled={loading}
              dataForGatewayPayment={dataForGatewayPayment}
              paymentActives={paymentActives}
              editMode="PAYMENT_MODE_ONLY"
            />
          ) : (
            <PaymentSplitter //
              fiscalType={fiscalType}
              amount={amount || 0}
              value={value || []}
              onChange={onChange}
              error={error}
              readonly={readonly}
              disabled={loading}
              dataForGatewayPayment={dataForGatewayPayment}
              paymentActives={paymentActives}
              depositCreation={depositCreation}
            />
          )}
        </Box>
      </Grid>
    </>
  )
}
